<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="homebox">
        <div class="textbox">
            <p>动境运动健康管理中心</p>
            <p>地址：朝阳区曙光西里甲5座18号三元NEO新境负一层</p>
            <p>联系电话：13810860950</p>
            <p>营业时间：9:00-18:00</p>
        </div>
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
export default {
  name: "about",
  data() {
    return {
      showpos2: false,
      msg: "",
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Home",
      });
    },
    gotoMyPage: function () {
      this.$router.push({
        name: "mypage",
      });
    },
    gotoSetPage: function () {
      this.$router.push({
        name: "Setpage",
      });
    },
    gotoRankPage: function () {
      this.$router.push({
        name: "Rankpage",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.homebox {
  width: 100vw;
  height: auto;
  position: relative;
  background-color: #181818;
}
.textbox{
    position: relative;
    left: 20vw;
    padding-top: 5vw;
    width: 60vw;
    height: auto;
    padding-bottom: 5vw;
}
.textbox p {
  color: #fff;
  font-size: 16px;
  text-align: left;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue